module.exports = __webpack_public_path__ + "static/media/FeedTime_web_3_preview.8777e268.jpg";